import {OctagonAlert} from 'lucide-react';
import {useState} from 'react';

import {usePanel} from '../app/PanelProvider.js';

/**
 * Pausa de emergência. O rótulo muda porque o botão é o mesmo interruptor dos
 * dois lados, como na prévia aprovada.
 */
export const EmergencyPauseButton = () => {
  const {paused, togglePause} = usePanel();
  const [busy, setBusy] = useState(false);

  const onClick = () => {
    if (busy) {
      return;
    }
    setBusy(true);
    void togglePause().finally(() => {
      setBusy(false);
    });
  };

  return (
    <button
      className="dm-emergency"
      type="button"
      aria-pressed={paused}
      onClick={onClick}
    >
      <OctagonAlert aria-hidden="true" />
      <span>{paused ? 'Retomar operação' : 'Pausar operação'}</span>
    </button>
  );
};
